export default __webpack_public_path__ + "img/fcPNsoWm.0f2c72c4.svg";